import { memo } from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import { makeStyles } from 'tss-react/mui';
import { getLocation } from '@sda/utils/location';
import { Map, Circle, Marker } from '@client/components/common/Map';
import type { UnknownLocation } from '@sda/utils/location/interfaces';

const useStyles = makeStyles({ name: 'FuzzedMap' })(() => ({
  placeIconSize: {
    fontSize: 40,
  },
}));

interface FuzzedMapProps {
  readonly location: UnknownLocation;
  readonly showExactLocation?: boolean;
  readonly defaultZoomLevel?: number;
  readonly height?: number;
}

export const FuzzedMap = memo<FuzzedMapProps>(({
  location, showExactLocation = false, defaultZoomLevel = 13, height = 300,
}) => {
  const { classes } = useStyles();
  const formattedLocation = getLocation(location);

  return (
    <Map
      location={formattedLocation}
      zoom={defaultZoomLevel}
      height={height}
    >
      {showExactLocation ? (
        <Marker
          lat={formattedLocation.lat}
          lng={formattedLocation.lng}
          offset={[-12, -21]}
        >
          <PlaceIcon className={classes.placeIconSize} />
        </Marker>
      ) : (
        <Circle
          lat={formattedLocation.lat}
          lng={formattedLocation.lng}
          radius={2000}
        />
      )}
    </Map>
  );
});
